import React, { useState } from "react";
import CustomModalBody from "components/Modal/body";
import CustomModalFooter from "components/Modal/footer";
import { Input, Form, FormGroup, Label, Row, Col } from "reactstrap";
import { requestError } from "utils/requestHandler";
import AgentNameTypeahead from "./AgentNameTypeahead";

const INVOICE_YEAR_MIN = 2024;

function getInvoiceYearOptions() {
	const currentYear = new Date().getFullYear();
	const endYear = Math.max(INVOICE_YEAR_MIN, currentYear);
	const years = [];
	for (let y = INVOICE_YEAR_MIN; y <= endYear; y += 1) {
		years.push(y);
	}
	return years;
}

const MONTHS = [
	{ value: "1", label: "January" },
	{ value: "2", label: "February" },
	{ value: "3", label: "March" },
	{ value: "4", label: "April" },
	{ value: "5", label: "May" },
	{ value: "6", label: "June" },
	{ value: "7", label: "July" },
	{ value: "8", label: "August" },
	{ value: "9", label: "September" },
	{ value: "10", label: "October" },
	{ value: "11", label: "November" },
	{ value: "12", label: "December" },
];

export default function FilterForm({
	onSubmit,
	onExport,
	onExportPdf,
	onChangeHOC,
	handleState,
	searchCommissionAgents,
}) {
	const [agentName, setAgentName] = useState("");
	const [agentCode, setAgentCode] = useState("");
	const [agentOptions, setAgentOptions] = useState([]);
	const [selectedAgent, setSelectedAgent] = useState(null);
	const [invoiceMonth, setInvoiceMonth] = useState("");
	const [invoiceYear, setInvoiceYear] = useState("");

	const handleClear = () => {
		setAgentName("");
		setAgentCode("");
		setAgentOptions([]);
		setSelectedAgent(null);
		setInvoiceMonth("");
		setInvoiceYear("");
	};

	const handleAgentSearch = (keyword) => {
		if (!keyword) {
			setAgentOptions([]);
			return;
		}
		if (typeof searchCommissionAgents !== "function") {
			return;
		}
		searchCommissionAgents(keyword, (options) => {
			setAgentOptions(options);
		});
	};

	const generateQuery = () => {
		let queryString = "";
		const name = agentName.trim();
		const code = agentCode.trim();

		if (name) {
			queryString += `&agent_name=${encodeURIComponent(name)}`;
		}
		if (code) {
			queryString += `&agent_code=${encodeURIComponent(code)}`;
		}
		if (invoiceMonth) {
			queryString += `&invoice_month=${encodeURIComponent(invoiceMonth)}`;
		}
		if (invoiceYear !== "" && invoiceYear !== null) {
			queryString += `&invoice_year=${encodeURIComponent(String(invoiceYear))}`;
		}

		return queryString;
	};

	return (
		<>
			<CustomModalBody>
				<Form id="commission-report-filter-form">
					<Row>
						<Col lg={3}>
							<AgentNameTypeahead
								value={selectedAgent}
								options={agentOptions}
								onSearch={handleAgentSearch}
								onChange={(option) => {
									setSelectedAgent(option);
									setAgentName(option?.name || "");
									setAgentCode(option?.code || "");
								}}
							/>
						</Col>
						{/* <Col lg={3}>
							<FormGroup>
								<Label for="agentCode">Agent Code</Label>
								<Input
									type="text"
									placeholder="Enter Agent Code"
									name="agentCode"
									id="agentCode"
									value={agentCode}
									onChange={(e) => setAgentCode(e.target.value)}
								/>
							</FormGroup>
						</Col> */}
						<Col lg={3}>
							<FormGroup>
								<Label for="invoiceMonth">Invoice Month</Label>
								<Input
									type="select"
									name="invoiceMonth"
									id="invoiceMonth"
									value={invoiceMonth}
									onChange={(e) => setInvoiceMonth(e.target.value)}
								>
									<option value="">Select month</option>
									{MONTHS.map((m) => (
										<option key={m.value} value={m.value}>
											{m.label}
										</option>
									))}
								</Input>
							</FormGroup>
						</Col>
						<Col lg={3}>
							<FormGroup>
								<Label for="invoiceYear">Invoice Year</Label>
								<Input
									type="select"
									name="invoiceYear"
									id="invoiceYear"
									value={invoiceYear}
									onChange={(e) => setInvoiceYear(e.target.value)}
								>
									<option value="">Select year</option>
									{getInvoiceYearOptions().map((y) => (
										<option key={y} value={String(y)}>
											{y}
										</option>
									))}
								</Input>
							</FormGroup>
						</Col>
					</Row>
				</Form>
			</CustomModalBody>
			<CustomModalFooter
				rightButton={[
					{
						color: "danger",
						outline: true,
						content: "Clear All",
						onClick: () => handleClear(),
					},
					{
						color: "primary",
						outline: true,
						content: "Export",
						onClick: () => {
							const name = agentName.trim();
							const code = agentCode.trim();
							// if (!name && !code) {
							if (!name) {
								requestError(
									// "Agent Name or Agent Code is required. Please fill in at least one."
									"Agent Name is required."
								);
								return;
							}
							const queryString = generateQuery();
							if (typeof onExport === "function") {
								onExport(queryString);
							}
							handleState({ filterQuery: queryString });
							onChangeHOC("showFilterModal", false);
							onChangeHOC("advertiserPages", 1);
						},
					},
					{
						color: "primary",
						outline: true,
						content: "Export PDF",
						onClick: () => {
							const name = agentName.trim();
							if (!name) {
								requestError("Agent Name is required.");
								return;
							}
							const queryString = generateQuery();
							if (typeof onExportPdf === "function") {
								onExportPdf(queryString);
							}
							handleState({ filterQuery: queryString });
							onChangeHOC("showFilterModal", false);
							onChangeHOC("advertiserPages", 1);
						},
					},
					{
						color: "primary",
						content: "Submit",
						onClick: () => {
							const name = agentName.trim();
							if (!name) {
								requestError("Agent Name is required.");
								return;
							}
							const queryString = generateQuery();
							if (typeof onSubmit === "function") {
								onSubmit(queryString);
							}
							handleState({ filterQuery: queryString });
							onChangeHOC("showFilterModal", false);
							onChangeHOC("advertiserPages", 1);
						},
					},
				]}
			/>
		</>
	);
}
